import { useState, useEffect } from "react";
import axios from "axios";

export default function UploadStep({ leadData, resetFlow, sendEvent }) {
  const { email, firstName, lastName } = leadData;

  const [mainPhoto, setMainPhoto]       = useState(null);
  const [refPhoto,  setRefPhoto]        = useState(null);
  const [description, setDescription]   = useState("");
  const [showPopup, setShowPopup]       = useState(false);
  const [progress,  setProgress]        = useState(0);
  const [isSending, setIsSending]       = useState(false);
  const [done,      setDone]            = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (err) {
      const t = setTimeout(() => setErr(""), 2000);
      return () => clearTimeout(t);
    }
  }, [err]);

  const MAX_SIZE = 256 * 1024 * 1024;

  const validateFile = (file, required = false) => {
    if (!file && required) return "File is required.";
    if (file && !file.type.startsWith("image/"))
      return "Only images allowed.";
    if (file && file.size > MAX_SIZE)
      return "Max size 256 MB.";
    return "";
  };

  const onMainChange = (e) => {
    const f = e.target.files[0];
    const msg = validateFile(f, true);
    if (msg) return setErr(msg);
    setMainPhoto(f);
  };

  const onRefChange = (e) => {
    const f = e.target.files[0];
    const msg = validateFile(f);
    if (msg) return setErr(msg);
    setRefPhoto(f);
  };

  const handleSend = async () => {
    const msg = validateFile(mainPhoto, true) ||
              (description.trim() ? "" : "Description is required.");
    if (msg) return setErr(msg);

    try {
      setIsSending(true);
      const fd = new FormData();
      fd.append("email", email);
      fd.append("firstName", firstName);
      fd.append("lastName",  lastName);
      fd.append("description", description.trim());
      fd.append("mainPhoto",  mainPhoto);
      if (refPhoto) fd.append("refPhoto", refPhoto);

      await axios.post("/api/upload", fd, {
        onUploadProgress: (e) => {
          if (e.total) setProgress(Math.round((e.loaded * 100) / e.total));
        }
      });

      await sendEvent("Deal Submitted", {
      userData:  { email, firstName, lastName },
      customData:{ ticket: "Retouch Request" }
    });

      setDone(true); 
    } catch (e) {
      console.error(e);
      alert("Upload failed. Please try again.");
    } finally {
      setIsSending(false);
    }
  };

  if (done)
    return (
      <div className="upload-step button-container">
        <p className="success-msg">Files received — stay tuned for my reply!</p>

        <button className="button" onClick={resetFlow}>
          <div className="button-content">
            <span className="button-text">Back to home</span>
          </div>
        </button>
      </div>
    );

  return (
    <div className="upload-step button-container">
      <label className="button">
        <input type="file" accept="image/*" hidden onChange={onMainChange} />
        <div className="button-content">
          <span className="button-text">
            {mainPhoto ? `${mainPhoto.name}` : "Upload photo (Required)"}
          </span>
        </div>
      </label>

      <label className="button">
        <input type="file" accept="image/*" hidden onChange={onRefChange} />
        <div className="button-content">
          <span className="button-text">
            {refPhoto ? `${refPhoto.name}` : "Upload reference (Optional)"}
          </span>
        </div>
      </label>

      <button type="button" className="button" onClick={() => setShowPopup(true)}>
        <div className="button-content">
          <span className="button-text">
            {description ? "Description added" : "Add description (Required)"}
          </span>
        </div>
      </button>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe any retouching wishes…"
            />
            <button className="button" onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}

      <button
        type="button"
        className="button"
        disabled={isSending || !mainPhoto}
        onClick={handleSend}
      >
        <div className="button-content">
          <span className="button-text">
            {isSending ? `Sending… ${progress}%` : "Submit"}
          </span>
        </div>
      </button>
      {err && <div className="form-error-overlay">{err}</div>}
    </div>
  );
}

